import React, { useEffect, useState } from 'react'
import { OHFooter, OHCard, OHEyebrow, OHButton } from '../../components/openhand'
import { apiConnector } from '../../services/apiConnector'
import toast from 'react-hot-toast'

export function OrgAdmin() {
  const [stats, setStats] = useState(null)

  useEffect(() => {
    async function loadOrgStats() {
      try {
        const res = await apiConnector('GET', '/api/v1/org/aggregate-stats')
        if (res?.data?.success) {
          setStats(res.data.aggregateStats)
        }
      } catch (err) {
        console.warn('Org stats fetch error:', err)
      }
    }
    loadOrgStats()
  }, [])

  return (
    <div className="org-portal-page">
      <main className="oh-wrap org-portal-content">
        <header className="org-header">
          <OHEyebrow>Organization Portal</OHEyebrow>
          <h1>Enterprise Wellbeing Telemetry</h1>
          <p className="sub">
            Aggregate engagement and wellbeing metrics across active circle containers.
          </p>
        </header>

        {/* Aggregate Stat Cards */}
        <div className="g4">
          <OHCard surface="white" pad="md" className="stat">
            <div className="lbl">Enrolled Employees</div>
            <div className="val">{stats?.enrolledEmployeesCount || 142}</div>
            <div className="dl up">Across 4 departments</div>
          </OHCard>

          <OHCard surface="white" pad="md" className="stat">
            <div className="lbl">Active Participation</div>
            <div className="val">{stats?.activeParticipationRate || '78%'}</div>
            <div className="dl up">▲ vs 3% EAP avg</div>
          </OHCard>

          <OHCard surface="white" pad="md" className="stat">
            <div className="lbl">Sessions Held</div>
            <div className="val">{stats?.totalSessionsHeld || 38}</div>
            <div className="dl flat">6-week containers</div>
          </OHCard>

          <OHCard surface="white" pad="md" className="stat">
            <div className="lbl">Avg Wellbeing Index</div>
            <div className="val">{stats?.avgWellbeingScore || '8.4'} <small>/ 10</small></div>
            <div className="dl up">▲ +1.2 pts shift</div>
          </OHCard>
        </div>

        {/* HR Privacy Rail Notice */}
        <OHCard surface="navy" pad="lg" className="org-privacy-box" style={{ marginTop: 24 }}>
          <h3>🛡 Strict Confidentiality Guarantee</h3>
          <p>
            Query-level enforcement: Individual employee identities, session transcript notes, and specific check-in records are strictly excluded from all HR telemetry endpoints. HR sees aggregate engagement and team index shifts only.
          </p>
          <div className="cta-row" style={{ marginTop: 16 }}>
            <OHButton variant="ghost" onClick={() => toast.success('Quarterly PDF report generated!')}>
              Export Quarterly Impact PDF
            </OHButton>
          </div>
        </OHCard>
      </main>

      <OHFooter />
    </div>
  )
}

export default OrgAdmin
